import { Button } from 'antd'
import { CIMSButtonProps } from './types'
import { useDisabledOptions } from '../../hooks/useDisabledOptions'
import CIMSTooltip from '../CIMSTooltip'
import { resolveValueOrArray } from '@cims-online/shared'

/**
 * wraps an ant design {@link Button} with a {@link CIMSTooltip}
 *
 * feel free to add more functionality to this component as needs arise...
 */
const CIMSButton: React.FC<CIMSButtonProps> = ({
  loading,
  disabled,
  tooltip,
  children,
  ...rest
}) => {
  const [disabledOptions, { some }] = useDisabledOptions([
    { disabled: !!loading, reason: 'loading' },
    ...resolveValueOrArray(disabled),
  ])
  return (
    <CIMSTooltip
      title={typeof tooltip === 'string' ? tooltip : tooltip?.title}
      placement={typeof tooltip === 'string' ? undefined : tooltip?.placement}
      disabled={disabledOptions}
    >
      <Button disabled={some || loading} loading={loading} {...rest}>
        {children}
      </Button>
    </CIMSTooltip>
  )
}

export default CIMSButton
